"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.5 1.11h-13c-.827 0-1.5.672-1.5 1.5v8.096c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5V2.61c0-.827-.673-1.5-1.5-1.5Zm.5 9.596a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V2.61a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v8.097ZM8 3.04a.57.57 0 1 0 0 1.138.57.57 0 0 0 0-1.138Zm.372 9.892h-1v.96H3.6v1h8.8v-1H8.372v-.96Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M22.5 16.996a.188.188 0 0 0 .188-.187V3.164a.188.188 0 0 0-.188-.188h-21a.188.188 0 0 0-.188.188v13.645c0 .103.085.187.188.187h21ZM1.5 1.851h21c.724 0 1.313.59 1.313 1.313v13.645c0 .723-.59 1.312-1.313 1.312h-21A1.314 1.314 0 0 1 .187 16.81V3.164c0-.724.59-1.313 1.313-1.313ZM12 4.558a.854.854 0 1 0 0 1.708.854.854 0 0 0 0-1.708Zm.371 14.838h-1.125v1.627H5.4v1.125h13.2v-1.125h-6.229v-1.627Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M30 22.662a.25.25 0 0 0 .25-.25V4.219a.25.25 0 0 0-.25-.25H2a.25.25 0 0 0-.25.25v18.193c0 .138.112.25.25.25h28ZM2 2.469h28c.965 0 1.75.785 1.75 1.75v18.193c0 .965-.785 1.75-1.75 1.75H2c-.965 0-1.75-.785-1.75-1.75V4.219c0-.965.785-1.75 1.75-1.75Zm14 3.608a1.14 1.14 0 1 0 0 2.278 1.14 1.14 0 0 0 0-2.278Zm.495 19.784h-1.5v2.17H7.2v1.5h17.6v-1.5h-8.305v-2.17Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M45.938 34.365H2.062V5.445h43.876v28.92ZM1.874 3.571h44.25c.93 0 1.688.757 1.688 1.687v29.295a1.69 1.69 0 0 1-1.688 1.687H1.875a1.69 1.69 0 0 1-1.688-1.687V5.258c0-.93.757-1.687 1.688-1.687ZM24 12.34a1.737 1.737 0 1 0 0-3.474 1.737 1.737 0 0 0 0 3.474Zm.549 26.698h-1.875v3.515H10.58v1.875h26.84v-1.875H24.55V39.04Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M61.25 45.82H2.75V7.26h58.5v38.56ZM2.5 4.761h59c1.24 0 2.25 1.009 2.25 2.25V46.07c0 1.241-1.01 2.25-2.25 2.25h-59a2.252 2.252 0 0 1-2.25-2.25V7.011a2.252 2.252 0 0 1 2.25-2.25ZM32 16.455a2.316 2.316 0 1 0 0-4.632 2.316 2.316 0 0 0 0 4.632Zm.732 35.597h-2.5v4.687H14.107v2.5h35.787v-2.5H32.732v-4.687Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconDesktop = function IconDesktop(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Desktop' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Desktop"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconDesktop.sizes = [16, 24, 32, 48, 64];
IconDesktop.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconDesktop;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Desktop.js
// module id = 1721
// module chunks = 0